import Vue from 'vue';
import VueRouter from 'vue-router'
import routes from './routes';
import $http from '@/http';


Vue.use(VueRouter);

//微信授权
async function getAuthorize() {
    let url = window.location.href;
    const result = await $http.home.getAuthorizeUrl({
        url
    });
    if (result.code === 200) {
        window.location.href = result.data.url;
    } 
}
const router = new VueRouter({
        routes,
        mode: 'hash'
    })
    // router.beforeEach((to, from, next) => {
    //     // let  path  =  window.location.href.split("=")[1];
    //     const uid = window.localStorage.getItem('uid')
    //     if (uid) {

//         next()
//     } else {
//         if (to.path === '/login') {
//             next()
//         } else { // 有此资源，没有登陆过，也不是登录页
//             next({ path: '/login' })
//         }
//     }
// })
export default router